import React from "react";
import "./Resources.css";
import mixpanel from "../../mixpanel";
import SimpleHeader from "../NewApp/SimpleHeader";
import vereVImg from "../../assets/verev-screenshot.webp";

const resources = [
  {
    category: "Ծառայություններ",
    icon: "💼",
    items: [{ label: "Փողային քոուչինգ (վճարովի)", href: "/coaching" }],
  },
  {
    category: "Հաշվիչներ",
    icon: "🧮",
    items: [
      { label: "Բարդ տոկոսի հաշվիչ", href: "/compound-interest-calculator" },
    ],
  },
  {
    category: "Գրքեր/checklists",
    icon: "📚",
    items: [
      { label: "Ներդրումներ ինդեքսներում գիրք", href: "/index-investing" },
      { label: "2025-ից դասերը", href: "/girls-and-finances-wrapped-2025" },
      { label: "Կապիտալի հիմքը", href: "/financial-literacy" },
      { label: "Մինչև վարկային պայմանագիրը կնքելը checklist", href: "/until-you-sign-the-loan" },
    ],
  },
  {
    category: "Հոդվածներ",
    icon: "📝",
    items: [{ label: "Կրթություն բաժնետոմսերում ներդրումների մասին", href: "/educational" }],
  },
  {
    category: "Ֆինանսական պլանավորում",
    icon: "💰",
    items: [
      { label: "Դուրս գալ պարտքից", href: "/get-out-of-debt" },
      { label: "Ստեղծել բյուջե", href: "/create-budget" },
      { label: "Կատարել ներդրումներ", href: "/invest" },
      { label: "Ներդրումային մտածելակերպ (բաժնետոմսերում)", href: "/investing-mindset" },
    ],
  },
];

const Resources: React.FC = () => {
  return (
    <div className="resources-page">
      <SimpleHeader
        onHome={() => (window.location.href = "/")}
        onResources={() => (window.location.href = "/resources")}
      />
      <div className="resources-background">
        <div className="gradient-blob blob-1"></div>
        <div className="gradient-blob blob-2"></div>
        <div className="gradient-blob blob-3"></div>
      </div>

      <div className="resources-container">
        <header className="resources-header">
          <h1 className="resources-title">Ռեսուրսներ և գործիքներ</h1>
        </header>

        <div className="resources-grid">
          {/* YouTube Featured Card */}
          <a
            href="https://youtu.be/9YK7kjrhd1s"
            target="_blank"
            rel="noopener noreferrer"
            className="resource-card featured-card featured-youtube"
            onClick={() => mixpanel.track("resources_youtube_clicked")}
          >
            <div className="featured-thumb">
              <img
                src="https://img.youtube.com/vi/9YK7kjrhd1s/mqdefault.jpg"
                alt="YouTube"
              />
              <div className="featured-thumb-overlay" />
              <span className="featured-play">▶</span>
            </div>
            <div className="featured-body">
              <span className="featured-badge">YouTube</span>
              <h2 className="featured-title">Ներդրումային տեսաշարք</h2>
              <p className="featured-sub">Ներդրումային տեսաշարքն արդեն Յութուբում է</p>
              <span className="featured-cta">Դիտել →</span>
            </div>
          </a>

          {/* VereV Featured Card */}
          <a href="/vereV" className="resource-card featured-card featured-verev" onClick={() => mixpanel.track("resources_verev_clicked")}>
            <div className="featured-thumb">
              <img src={vereVImg} alt="VereV" />
              <div className="featured-thumb-overlay" />
            </div>
            <div className="featured-body">
              <span className="featured-badge">Նոր խաղ</span>
              <h2 className="featured-title">VereV</h2>
              <p className="featured-sub">Ֆինանսական գրագիտության խաղ ամբողջ ընտանիքի համար</p>
              <span className="featured-cta">Խաղալ →</span>
            </div>
          </a>

          {resources.map((resource, index) => (
            <div key={index} className="resource-card">
              <div className="resource-icon">{resource.icon}</div>
              <h2 className="resource-category">{resource.category}</h2>
              <ul className="resource-links">
                {resource.items.map((item, itemIndex) => (
                  <li key={itemIndex}>
                    <a href={item.href} className="resource-link" onClick={() => mixpanel.track(`resources_link_clicked`, { href: item.href })}>
                      {item.label}
                      <span className="arrow">→</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Newsletter Card */}
          <div className="resource-card newsletter-card">
            <div className="resource-icon">💌</div>
            <h2 className="resource-category">Միացեք նյուզլեթերին</h2>
            <p className="newsletter-description">
              Ստացեք ֆինանսական կրթական հոդվածներ և նորություններ Ձեր էլ.
              հասցեին
            </p>
            <a
              href="https://girlsandfinances.substack.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="newsletter-button"
              onClick={() => mixpanel.track("resources_newsletter_clicked")}
            >
              Բաժանորդագրվել
              <span className="arrow">→</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resources;
